import { IconCursoIngles, IconEnsinoMedio, IconFaculdade } from "./icons";
import imagemIfpr from "../assets/schools/ifpr.jpeg";
import imagemCultural from "../assets/schools/cultural.jpg";
import imagemBarbosa from "../assets/schools/barbosa.jpg";

export const translateFormacao = {
  pt: [
    {
      id: 3,
      instituicao: "Colégio Estadual Barbosa Ferraz • Ivaiporã PR",
      curso: "Ensino Médio Técnico em Informática",
      periodo: "2016 — 2019",
      descricao: "",
      icone: <IconEnsinoMedio/>
    },
    {
      id: 1,
      instituicao: "IFPR | Instituto Federal do Paraná • Londrina PR",
      curso: "Tecnologia em Análise e Desenvolvimento de Sistemas",
      periodo: "2023-2026",
      descricao: "",
      icone: <IconFaculdade/>
    },
    {
      id: 2,
      instituicao: "Cultural American Space • Londrina PR",
      curso: "Curso de Língua Inglesa",
      periodo: "02/2026 - Presente",
      descricao: "",
      icone: <IconCursoIngles/>
    },
    
  ],
  
  en: [
    {
      id: 1,
      instituicao: "IFPR | Federal Institute of Paraná • Londrina PR",
      curso: "Systems Analysis and Development Degree",
      periodo: "2023-2026",
      descricao: "",
      imagem: imagemIfpr,
      icone: <IconFaculdade/>
    },
    {
      id: 2,
      instituicao: "Cultural American Space • Londrina PR",
      curso: "English Language Course",
      periodo: "02/2026 - Present",
      descricao: "",
      imagem: imagemCultural,
      icone: <IconCursoIngles/>
    },
    {
      id: 3,
      instituicao: "Colégio Estadual Barbosa Ferraz • Ivaiporã PR",
      curso: "Technical High School in Information Technology",
      periodo: "2016 — 2019",
      descricao: "",
      imagem: imagemBarbosa,
      icone: <IconEnsinoMedio/>
    }
  ]
};
